type GetSignupPromotionalEmailPreferenceArgs = {
  isFieldVisible: boolean;
  wantsPromotionalEmails: boolean;
};

export const getSignupPromotionalEmailPreference = ({
  isFieldVisible,
  wantsPromotionalEmails,
}: GetSignupPromotionalEmailPreferenceArgs) => (isFieldVisible ? wantsPromotionalEmails : false);
